import { __read } from "tslib";
import { useCallback, useRef, useState } from 'react';
import { useUpdateEffect } from '../useUpdateEffect';
/**
 * @internal
 */
export function useTextFieldHint(props) {
    var htmlHint = props.hint;
    var _a = __read(useState(htmlHint), 2), hint = _a[0], setHint = _a[1];
    var _b = __read(useState(false), 2), isLeave = _b[0], setHintLeave = _b[1];
    var prevHint = useRef(htmlHint);
    useUpdateEffect(function () {
        if (htmlHint) {
            setHint(htmlHint);
        }
        setHintLeave(Boolean(prevHint.current && !htmlHint));
        prevHint.current = htmlHint;
    }, [htmlHint]);
    var onAnimationEnd = useCallback(function () {
        if (!htmlHint) {
            setHint('');
            setHintLeave(false);
        }
    }, [htmlHint]);
    return {
        hint: hint,
        hintProps: {
            leave: isLeave,
            onAnimationEnd: onAnimationEnd,
        },
    };
}
